module.exports = __webpack_public_path__ + "static/media/lb-email.fc241125.svg";